import BeforeAfterUi from "./BeforeAfterUi";
import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import { getLocalData } from "../../Services/common";
import { HOSPITAL_DATA } from "../../Constants/storageConstant";
import { isNullOrEmpty } from "../../Utils/stringUtils";
import * as toast from "../../Wrapper/toast/toast";
import {
  AFTER_IMAGE_REQUIRED,
  BEFORE_AFTER_IMAGE_REQUIRED,
  BEFORE_IMAGE_REQUIRED,
} from "../../Constants/stringConstants";
const BeforeAfter = () => {
  const posterRef = useRef();
  let hospitalData = getLocalData(HOSPITAL_DATA);

  const [beforeImage, setBeforeImage] = useState(null);
  const [afterImage, setAfterImage] = useState(null);

  const handleImageChange = (e, setter) => {
    const file = e.target.files[0];

    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      toast.warn("Only image files are allowed.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => setter(reader.result);
    reader.readAsDataURL(file);
  };

  const validation = () => {
    let validate = true;
    if (isNullOrEmpty(beforeImage) && isNullOrEmpty(afterImage)) {
      validate = false;
      toast.warn(BEFORE_AFTER_IMAGE_REQUIRED);
    } else if (isNullOrEmpty(beforeImage)) {
      validate = false;
      toast.warn(BEFORE_IMAGE_REQUIRED);
    } else if (isNullOrEmpty(afterImage)) {
      validate = false;
      toast.warn(AFTER_IMAGE_REQUIRED);
    }
    return validate;
  };
  const downloadPoster = async () => {
    if (validation()) {
      const hideEls = document.querySelectorAll(".hide-on-capture");
      hideEls.forEach((el) => (el.style.display = "none"));

      const canvas = await html2canvas(posterRef.current);
      const link = document.createElement("a");
      link.download = "hospital_poster.png";
      link.href = canvas.toDataURL();
      link.click();

      // Restore visibility
      hideEls.forEach((el) => (el.style.display = ""));
    }
  };

  return (
    <BeforeAfterUi
      hospitalData={hospitalData}
      beforeImage={beforeImage}
      setBeforeImage={setBeforeImage}
      afterImage={afterImage}
      setAfterImage={setAfterImage}
      handleImageChange={handleImageChange}
      downloadPoster={downloadPoster}
      posterRef={posterRef}
    />
  );
};
export default BeforeAfter;
